import moment from 'moment';
import {
    CRUD_GET_LIST_SUCCESS,
} from 'store/actions/dataActions';
import { LOCATION_CHANGE } from 'connected-react-router';
import { 
    DATE_FORMAT_ONLY_DATE,
    DATE_FORMAT_ONLY_TIME
} from 'util/constants';
import { getHumanReadableFileSize } from 'util/common';

const initialState = [];
let previousPathname = '';

export default ( previousState = initialState, { type, payload, meta } ) => {

    switch (type) {

        case LOCATION_CHANGE://다른 메뉴로 이동하는 경우 구조가 달라 에러발생하므로 초기화
            if( previousPathname !== '' && previousPathname !== payload.location.pathname && payload.isKeepItem !== true ) {
                previousPathname = payload.location.pathname;
                return initialState;
            } else {
                previousPathname = payload.location.pathname;
                return previousState;
            }

        case CRUD_GET_LIST_SUCCESS:
            if( meta.menu === 'DOCUMENT.FILE') {
                const today = new Date();

                let documents = payload.content.map( document => {
                    const dateInfo = moment(document["date"]);
                    return {
                        ...document,
                        date: dateInfo.isSame(today, 'day') 
                            ? dateInfo.format(DATE_FORMAT_ONLY_TIME) : dateInfo.format(DATE_FORMAT_ONLY_DATE),
                        fileSize: getHumanReadableFileSize(document["fileSize"]),
                    }

                });

                return { documents: documents || [] };
            } 

            return previousState;

         default:
            return previousState;
    }

}
